/** user_ai_skills 表记录 */
export interface UserAiSkillRecord {
  readonly id: string;
  readonly user_id: string;
  readonly production_id: string;
  readonly date_created: string;
  readonly status: 'active' | 'expired';
}

/** ai_skill_instances 表记录 */
export interface AiSkillInstanceRecord {
  readonly id: string;
  readonly production_id: string;
  readonly skill_name: string;
  readonly mind_capability_id: number;
  readonly mind_skill_id: string;
  readonly date_created: string;
}

/** 扁平化后的可选技能项（用于下拉多选） */
export interface SkillOption {
  readonly id: string;
  readonly name: string;
}

/**
 * 将选中的 skill 格式化为 Dify 要求的参数格式
 * 格式: §[file].[app].[id]§
 * 多个用连接：§[file].[app].[id1]§§[file].[app].[id2]§
 */
export const formatSkillsParam = (selectedIds: readonly string[]): string => {
  return selectedIds
    .map((id: string): string => `§[file].[app].[${id}]§`)
    .join('');
};